<template>
  <div id="app">
    <navbar />
    <router-view/>
    <navBottom />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import NavBottom from '@/components/NavBottom.vue';

export default {
  components: {
    Navbar,
    NavBottom,
  },

};
</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Roboto');

html, body {
  font-family: 'Roboto', sans-serif;
}

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

*, html {
    margin:0;
    padding:0;
}

body{
  background-color: transparent !important;
  min-height:450px;
}

html {
  /* background: url('./assets/Background.jpg') no-repeat center center fixed;*/
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color:  #fff;
}

a {
  color: #356e4c;
}

#nav-collapse a.router-link-exact-active {
  color: #00422d !important;
}

#nav-collapse a {
  color: #356e4c;
}

.figure-caption {
  color: #000 !important;
  font-size: 16px !important;
}

</style>
